import { render, staticRenderFns } from "./QuotationTable.vue?vue&type=template&id=4822f321&"
import script from "./QuotationTable.vue?vue&type=script&lang=js&"
export * from "./QuotationTable.vue?vue&type=script&lang=js&"
import style0 from "./QuotationTable.vue?vue&type=style&index=0&id=4822f321&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports